module.exports = __webpack_public_path__ + "img/emoji_167.d3d79fcb.png";